import { NgClass } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { DiagnosticRating, PlatformKey } from '@malou-io/package-utils';

import type { Diagnostic } from ':shared/models';

import { SvgIcon } from ':shared/enums';
import { LogoPathResolverPipe } from ':shared/pipes';

@Component({
    selector: 'app-restaurant-information',
    imports: [TranslateModule, MatIconModule, LogoPathResolverPipe, NgClass],
    templateUrl: './restaurant-information.component.html',
    styleUrl: './restaurant-information.component.scss',
})
export class RestaurantInformationComponent {
    diagnostic = input.required<Diagnostic>();
    isScorePreview = input<boolean>(false);
    scoreRating = input<DiagnosticRating | null>(null);

    readonly PlatformKey = PlatformKey;
    readonly SvgIcon = SvgIcon;
    readonly DiagnosticRating = DiagnosticRating;

    readonly instagramAccount = computed(() => this.diagnostic()?.instagramPage?.name);
    readonly instagramProfilePictureUrl = computed(() => this.diagnostic()?.instagramPage?.profilePictureUrl ?? null);
    readonly restaurantName = computed(() => this.diagnostic()?.restaurant.name);
    readonly restaurantAddress = computed(() => this.diagnostic()?.restaurant.address.formattedAddress);
}
